export const ServiceCodes = {
  Lifting: 'LIFTING',
  Pickup: 'UNLOADING',
  Manipulator: 'MANIPULATOR',
  Courier: 'COURIER',
  Other: 'OTHER',
} as const;

export type ServiceCodes = (typeof ServiceCodes)[keyof typeof ServiceCodes];

export const TimeSlotIntervalTypes = {
  Standard: 'standard',
  Express: 'express',
  ExactlyInTime: 'exactly_in_time',
} as const;

export type TimeSlotIntervalTypes = (typeof TimeSlotIntervalTypes)[keyof typeof TimeSlotIntervalTypes];

export const DELIVERY_ERROR_MESSAGE = 'менеджер уточнит условия оплаты и возможность доставки после оформления заказа';
